module.exports = __webpack_public_path__ + "static/media/brand-refresh-logo-apple.8cb10127.svg";